import React, { useState } from "react";
import { TextField, Chip, InputAdornment, IconButton } from "@mui/material";
import AddCircle from "@mui/icons-material/AddCircle";

const ChipsInput = ({ chips, setChips, label, error }) => {
  const [inputValue, setInputValue] = useState("");
  const handleAddChip = () => {
    if (inputValue.trim() !== "") {
      setChips([...chips, inputValue.trim()]);
      setInputValue("");
    }
  };

  const handleDeleteChip = (chipToDelete) => () => {
    setChips(chips.filter((chip) => chip !== chipToDelete));
  };
  return (
    <TextField error={error}
      variant="outlined"
      fullWidth
      label={label}
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault(); // Sayfanın yenilenmesini engeller
          handleAddChip();
        }
      }}
      InputProps={{
        startAdornment: chips.map((chip, index) => (
          <Chip
            key={index}
            label={chip}
            onDelete={handleDeleteChip(chip)}
            style={{ marginRight: 2 }}
          />
        )),
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={handleAddChip}>
              <AddCircle />
            </IconButton>
          </InputAdornment>
        )
      }}
    />
  );
};

export default ChipsInput;
